
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_VIEW_FUSION(name: string = "unnamed", BH: BlocklyHelperService, fusionData: string[]): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.FUSION, name: name, contents: [] };

  cat.contents = [
    BH.label("Fusion-View Funktionen"),
    BH.fusion("SWITCH_FUSION_VIEW", "Wechsle Fusion-View auf: {{fusion:dropdown=" + fusionData.join(',') + "}}", "RAGAI.FUSIONVIEW.goToFusionView('{{fusion}}');"),
    BH.fusion("FV_VIEW_SWITCH", "Fusion-View Modus: {{viewname:dropdown=Bot im Vollbild |full(),Bot im Fenster Modus|window(),Bot Floating Ansicht|float(),Side by side Ansicht|split()}}", "RAGAI.PARENT.exec('FUSION.VIEW_MODE.{{viewname}}');"),
    BH.fusion("FV_BOT_BTN_VISIBILITY", "Fusion-View Bot Button: {{btnstate:dropdown=Anzeigen|show(),Verstecken|hide()}}", "RAGAI.PARENT.exec('FUSION.BTN.{{btnstate}}');"),
    BH.fusion("FV_BOT_VISIBILITY", "Fusion-View Bot: {{btnstate:dropdown=Anzeigen|show(),Verstecken|hide()}}", "RAGAI.PARENT.exec('FUSION.BOT.{{btnstate}}');"),
    //BH.fusion("FV_BOT_AVATAR", "Fusion-View Bot-Button Bild: {{avatarUrl[@check=URL] }}", "RAGAI.PARENT.exec('FUSION.BTN.setAvatar({{avatarUrl}})');"),


    BH.withNested(BH.styling("LOAD_EXTERNAL_CSS_IN_FUSION", "Fusion-View: Lade externe CSS-Datei {{url[@check=URL] }}", "RAGAI.PARENT.exec('FUSION.loadExternalCSS({{url}})');"),
      [{ forValue: "url", isShadow: true, targetBlockType: 'DUMMY_URL' }]
    ),
    BH.withNested(BH.styling("LOAD_EXTERNAL_JS_IN_FUSION", "Fusion-View: Lade externe JS-Datei {{url[@check=URL] }}", "RAGAI.PARENT.exec('FUSION.loadExternalJS({{url}})');"),
      [{ forValue: "url", isShadow: true, targetBlockType: 'DUMMY_URL' }]
    )



  ];

  return cat;
}
